import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initPerfDetector } from './canvas/perfDetector';

// `colors_and_type.css` is deliberately not imported: it is a reference token
// sheet (as it was in 7.3.x, where no HTML linked it). `src/tokens.ts` is the
// live source of truth, and importing it would duplicate the font request.
import './global.css';

// Classify the device before the first render, so components mount with the
// right tier rather than downgrading visibly a moment later.
initPerfDetector();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
